export default {
  namespaced: true,
  state: {
    tokenAuth: false,
    username: "",
    optionsMenu: [],
  },
  mutations: {
    setAuthToken(state, val) {
      state.tokenAuth = val.status;
      state.username = val.username;
    },
    SET_OPTIONS_MENU(state, val) {
      state.optionsMenu = val;
    },
   
  },
  getters: {
    isAuthenticated(state) {
      return state.tokenAuth;
    },
    options(state) {
      return state.options;
    },
  },
};
